/**
  * 员工 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const giveawardku = {
    // 列表
    list (params) {
        return axios.get(api + 'giveawardku/list', { params: params })
    },
    goodlist (params) {
        return axios.get(api + 'giveawardku/goodlist', { params: params })
    },
    loglist (params) {
        return axios.get(api + 'giveawardku/loglist', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'giveawardku/create', qs.stringify(params))
    },
    //修改
    status (params) {
        return axios.post(api + 'giveawardku/status', qs.stringify(params))
    },
    remove (params) {
        return axios.post(api + 'giveawardku/remove', qs.stringify(params))
    },
}


// 导出接口
export default giveawardku